import { jsx as _jsx } from "react/jsx-runtime";
import { AnimatedMessaging } from '../animation/MessagingAnimations';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import { StyledIllustration, StyledMessagingIllustration } from './Messaging.styles';

const MessageIllustration = ({
  messageKey
}) => {
  const {
    illustrationName,
    height
  } = getMessage(messageKey);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(illustrationName);
  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsx(StyledIllustration, {
      messageKey: messageKey,
      children: /*#__PURE__*/_jsx(BaseMessageCaption, {
        messageKey: messageKey,
        children: /*#__PURE__*/_jsx(StyledMessagingIllustration, {
          height: height,
          name: illustrationName,
          onLoad: handleImageLoaded
        })
      })
    })
  });
};

export default MessageIllustration;